import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import "./Products.css";

const Products = () => {
  const vantaRef = useRef(null);
  const vantaEffect = useRef(null); // Use useRef to persist the instance
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 480); // Check for mobile screen width
    };

    handleResize(); // Check on initial load
    window.addEventListener("resize", handleResize); // Add resize listener

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup listener
    };
  }, []);

  useEffect(() => {
    const initializeVanta = () => {
      if (!vantaEffect.current && window.VANTA) {
        vantaEffect.current = window.VANTA.WAVES({
          el: vantaRef.current,
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200.0,
          minWidth: 200.0,
          scale: 1.0,
          scaleMobile: 1.0,
          color: 0x1263b,
          waveSpeed: 0.75,
          waveHeight: 30.0,
        });
      }
    };

    // Check if VANTA is loaded and initialize
    const scriptCheckInterval = setInterval(() => {
      if (window.VANTA) {
        initializeVanta();
        clearInterval(scriptCheckInterval);
      }
    }, 100);

    return () => {
      // Destroy VANTA effect on component unmount
      if (vantaEffect.current) {
        vantaEffect.current.destroy();
        vantaEffect.current = null;
      }
      clearInterval(scriptCheckInterval);
    };
  }, []);

  const products = [
    {
      name: "Biolingo",
      icon: "Icons/Icon_Plant.png",
      description: "AI-driven bio-sensors for plant well-being tracking.",
      buttonLink: "/biolingo",
    },
    {
      name: "Happimeter",
      icon: "Icons/happimeter.png",
      description: "Smartwatch sensors to turn mood and body data into self-awareness.",
      buttonLink: "https://happimeter.socialcompass.ai",
      external: true,
    },
    {
      name: "SocialCompass",
      icon: "Icons/Icon_Compass.png",
      description: "Navigate your emotional world — AI-powered analysis of communication patterns to boost collaboration, creativity, and well-being.",
      buttonLink: "https://socialcompass.ai",
      external: true,
    },
    {
      name: "SC Chat Analyzer",
      icon: "Icons/sc.png",
      description: "Transforms text into emotional insight - rebuilds non-verbal cues to support emotional awareness and well-being.",
      buttonLink: "/chatAnalyzer",
    },
  ];

  return (
    <section
      id="products"
      className="products-section"
      ref={vantaRef}
      style={{ position: "relative", overflow: "hidden", minHeight: "100vh" }}
    >
      {/* Header Section */}
      <div className="products-header">
        <h2 className="products-title">Galaxy Products</h2>
        <p className="products-subtitle">
          AI-powered tools for well-being, collaboration, and communication.
        </p>
      </div>

      {/* Product Rows */}
      <div className="products-container">
        {products.map((product, index) => (
          <div
            key={index}
            className={`product-row ${isMobile ? "product-row-mobile" : ""}`} // Add mobile-specific class
          >
            {/* Icon */}
            <div className="product-icon-container">
              <img
                src={product.icon}
                alt={`${product.name} Icon`}
                className="product-icon"
              />
            </div>

            {/* Text */}
            <div className="product-info">
              <h3 className="product-name">{product.name}</h3>
              <p className="product-description">{product.description}</p>
              {product.external ? (
                <a href={product.buttonLink} target="_blank" rel="noopener noreferrer" className="learn-more-button">
                  Learn More
                </a>
              ) : (
                <Link to={product.buttonLink} className="learn-more-button">
                  Learn More
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Products;
